<div class="quarantine-user-dialog">
  <app-popup-top-line></app-popup-top-line>

  <div class="quarantine-user-dialog-header">
    <div class="title">
      Quarantine User
      <div class="description">Report a security incident to your preferred SIEM/SOAR system</div>
    </div>
    <img class="close-button" src="assets/images/common/cancel.svg" (click)="onClose()" />
  </div>
  <div class="quarantine-user-dialog-body">
    <mat-dialog-content>
      <p>Take action to isolate a potentially malicious user</p>
      <app-prime-table
        #table
        class="quarantine-user-dialog-table-component"
        queryParamProperty="user"
        [data$]="usersCurrentPage$"
        [rowsPerPage]="50"
        [columns]="columns()"
        [isLoading]="(isLoading$ | async) === true"
        (rowSelected)="rowSelected($event)"
        (rowUnselected)="rowUnselected()"
        [withActions]="false"
        [pageInfo]="pageInfo$.value"
        [sortedColumn$]="sortedColumn$"
        [checkedRowsSupportedActions$]="multiSelectedMenuActions$"
        tableNotFoundText="No issues found"
        (checkedRowsUpdate)="onCheckboxClick($event)"
        tableNotFoundIcon="assets/images/common/no-results-found.svg"
      />

      <p>Select Isolation Actions</p>
      <mat-form-field class="actions-select">
        <mat-label>Actions</mat-label>
        <mat-select [formControl]="actions" multiple>
          <mat-select-trigger>
            {{ actions.value?.[0] || '' }}
            @if ((actions.value?.length || 0) > 1) {
              <span class="additional-selection">
                (+{{ (actions.value?.length || 0) - 1 }} {{ actions.value?.length === 2 ? 'other' : 'others' }})
              </span>
            }
          </mat-select-trigger>
          @for (action of actionList; track action) {
            <mat-option [value]="action">{{ action }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      @if (selectedUsersNames !== '') {
        <div class="p-icon">
          <mat-icon class="attention-icon" fontIcon="warning"></mat-icon>
          <p>
            To confirm these actions for this user, please type their name exactly as shown:
            <br />
            <span>{{ selectedUsersNames }}</span>
          </p>
        </div>
      }
      <mat-form-field>
        <input [formControl]="actionOnUsers" matInput placeholder="Type the user's name here..." />
      </mat-form-field>
    </mat-dialog-content>
  </div>
  <div class="quarantine-user-dialog-footer">
    <mat-dialog-actions align="end">
      <app-button
        [isEnabled]="isExecuteActionsEnable()"
        [buttonTextLabelPath]="'issuesPage.quarantineUserDialog.executeActionsButton'"
        (buttonClicked)="onExecuteActions()"
      ></app-button>
    </mat-dialog-actions>
  </div>
</div>
